import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import moment from "moment/moment";
import api from "../setupMiddleware";
import { toast, Bounce, ToastContainer } from "react-toastify";

export async function exportSalaryReport(salaryData, month, year, user_id) {
  const workbook = new ExcelJS.Workbook();
  const sheet = workbook.addWorksheet("WPS Salary File");

  const EDR = salaryData?.EDR;
  const SCR = salaryData?.SCR;
  const FINAL = salaryData?.final_data;

  // ====== HEADER ======
  const header = [
    "",
    "Name",
    "Employee personal Number",
    "Bank Routing Code",
    "Bank Account Number",
    "Pay Start Date",
    "Pay End Date",
    "Days in period",
    "Fixed Salary",
    "Variable Salary",
    "Days on leave",
  ];

  sheet.addRow(header);

  // Style header row
  const headerRow = sheet.getRow(1);
  headerRow.eachCell((cell, colNumber) => {
    cell.font = { bold: true, name: "Arial", size: 10 };
    cell.alignment = { horizontal: "center", vertical: "middle" };
    cell.border = {
      top: { style: "thin" },
      left: { style: "thin" },
      bottom: { style: "thin" },
      right: { style: "thin" },
    };
    if (colNumber % 2 === 0) {
      cell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "FFFDE9D9" }, // blue fill like your header
      };
    }
  });

  // ====== EDR ROWS ======
  EDR.forEach((item) => {
    const user = item.user || {};
    const row = [
      "EDR",
      `${user.first_name || ""} ${user.last_name || ""}`.trim(),
      user.employee_personal_number || "",
      user.bank_routing_code || "",
      user.bank_account_number || "",
      item.start_date || "",
      item.end_date || "",
      item.days_in_month || "",
      parseFloat(item.net_salary || 0),
      0,
      item.leave_days || 0,
    ];
    const newRow = sheet.addRow(row);

    // Light peach background
    newRow.eachCell((cell, colNumber) => {
      cell.font = { name: "Arial", size: 10 };
      cell.border = {
        top: { style: "thin" },
        left: { style: "thin" },
        bottom: { style: "thin" },
        right: { style: "thin" },
      };
      if (colNumber % 2 === 0) {
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "FFFDE9D9" },
        };
      }
    });
  });

  // ====== SCR SECTION ======
  sheet.addRow([
    "",
    "",
    "Employer MOL",
    "Agent ID",
    "Date",
    "Time",
    "Salary Month",
    "Number of EDR",
    "Total Salary",
    "currency",
    "Company name",
  ]);

  const scrCols = [
    `A${EDR?.length + 2}`,
    `B${EDR?.length + 2}`,
    `C${EDR?.length + 2}`,
    `D${EDR?.length + 2}`,
    `E${EDR?.length + 2}`,
    `F${EDR?.length + 2}`,
    `G${EDR?.length + 2}`,
    `H${EDR?.length + 2}`,
    `I${EDR?.length + 2}`,
    `J${EDR?.length + 2}`,
    `K${EDR?.length + 2}`,
  ];
  scrCols.forEach((cellRef) => {
    const cell = sheet.getCell(cellRef);
    const colNumber = cell.col;
    cell.font = { name: "Arial", size: 10 };
    cell.alignment = { horizontal: "center", vertical: "middle" };
    cell.border = {
      top: { style: "thin" },
      left: { style: "thin" },
      bottom: { style: "thin" },
      right: { style: "thin" },
    };
    if (colNumber % 2 === 0) {
      cell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "FFFDE9D9" }, // blue fill like your header
      };
    } else if (colNumber !== 1) {
      // Odd columns except first column
      cell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "FFF2F2F2" }, // Light gray / beige
      };
    }
  });

  const scrRow = sheet.addRow([
    "SCR",
    "",
    SCR.employer_mol,
    SCR.agent_id,
    SCR.date,
    SCR.time,
    SCR.salary_month,
    SCR["Number of EDR"],
    SCR.total_salary,
    SCR.currency,
    SCR.company_name,
  ]);
  scrRow.eachCell((cell, colNumber) => {
    cell.font = { name: "Arial", size: 10 };
    cell.alignment = { horizontal: "center", vertical: "middle" };
    cell.border = {
      top: { style: "thin" },
      left: { style: "thin" },
      bottom: { style: "thin" },
      right: { style: "thin" },
    };
    if (colNumber % 2 === 0) {
      cell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "FFFDE9D9" }, // blue fill like your header
      };
    } else if (colNumber !== 1) {
      // Odd columns except first column
      cell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "FFF2F2F2" }, // Light gray / beige
      };
    }
  });

  // ====== CHARGES SECTION ======
  sheet.addRow([]);
  sheet.addRow([]);
  sheet.addRow(["", "", "Each employee", "Number of employee", "Total"]);

  sheet.addRow([
    "",
    "Charges",
    FINAL.each_employee_charge,
    FINAL.number_of_employees,
    FINAL.total_charge,
  ]);
  sheet.addRow(["", "File charges", "", "", FINAL.file_charge]);
  sheet.addRow(["", "", "", "Total", FINAL.total]);
  sheet.addRow(["", "", "", "Vat", FINAL.vat]);
  sheet.addRow(["", "", "", "Total with VAT", FINAL.total_with_vat]);
  sheet.addRow([]);
  sheet.addRow(["", "", "", "", FINAL.final_amount]);

  // ====== STYLE SPECIFIC COLUMNS ======
  const borderCols = [
    `B${EDR?.length + 6}`,
    `C${EDR?.length + 6}`,
    `D${EDR?.length + 6}`,
    `E${EDR?.length + 6}`,
    `B${EDR?.length + 7}`,
    `C${EDR?.length + 7}`,
    `D${EDR?.length + 7}`,
    `E${EDR?.length + 7}`,
    `B${EDR?.length + 8}`,
    `C${EDR?.length + 8}`,
    `D${EDR?.length + 8}`,
    `E${EDR?.length + 8}`,
    `B${EDR?.length + 9}`,
    `C${EDR?.length + 9}`,
    `D${EDR?.length + 9}`,
    `E${EDR?.length + 9}`,
    `B${EDR?.length + 10}`,
    `C${EDR?.length + 10}`,
    `D${EDR?.length + 10}`,
    `E${EDR?.length + 10}`,
    `B${EDR?.length + 11}`,
    `C${EDR?.length + 11}`,
    `D${EDR?.length + 11}`,
    `E${EDR?.length + 11}`,
  ];
  borderCols.forEach((cellRef) => {
    const cell = sheet.getCell(cellRef);
    cell.font = { name: "Arial", size: 10 };
    cell.border = {
      top: { style: "thin" },
      left: { style: "thin" },
      bottom: { style: "thin" },
      right: { style: "thin" },
    };
    cell.alignment = { horizontal: "center", vertical: "middle" };
  });

  const border2Cols = [`D${EDR?.length + 11}`, `E${EDR?.length + 11}`];
  border2Cols.forEach((cellRef) => {
    const cell = sheet.getCell(cellRef);
    cell.font = { bold: true };
  });

  // ====== Column widths ======
  const widths = [8, 25, 25, 20, 30, 15, 15, 15, 15, 15, 20];
  widths.forEach((w, i) => {
    sheet.getColumn(i + 1).width = w;
  });

  sheet.columns.forEach((column) => {
    let maxLength = 0;
    column.eachCell({ includeEmpty: true }, (cell) => {
      const cellValue = cell.value ? cell.value.toString() : "";
      maxLength = Math.max(maxLength, cellValue.length);
    });
    // Add some padding
    column.width = maxLength + 2;
  });

  // ====== Export file ======
  // const buffer = await workbook.xlsx.writeBuffer();
  // saveAs(
  //   new Blob([buffer], {
  //     type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  //   }),
  //   `WPS_SALARY_FILE_${moment()
  //     .month(month - 1)
  //     .format("MMM")}_${year}.xlsx`
  // );

  const buffer = await workbook.xlsx.writeBuffer();
  const fileName = `WPS_SALARY_FILE_${moment()
    .month(month - 1)
    .format("MMM")}_${year}.xlsx`;

  // ===== Upload before saving =====
  const file = new File([buffer], fileName, {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });

  return file;
}
